<template>
  <component
    :id="
      slugify(data.text, {
        lower: true,
        strict: true,
      })
    "
    :class="['editorHeader', `editorHeader--h${data.level}`]"
    :is="`h${data.level}`"
  >
    <div v-html="data.text"></div>
  </component>
</template>

<script>
import slugify from 'slugify';

export default {
  name: 'EditorParagraph',
  methods: { slugify },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
.editorHeader {
  font-weight: 600;

  &--h1 {
    font-size: 3.6rem;
    line-height: 4.5rem;
  }

  &--h2 {
    font-size: 2.8rem;
    line-height: 4rem;
  }

  &--h3 {
    font-size: 2.2rem;
    line-height: 2.8rem;
  }

  &--h4 {
    font-size: 2rem;
    line-height: 2.6rem;
  }

  &--h5 {
    font-size: 1.8rem;
    line-height: 2.6rem;
  }

  &--h6 {
    font-size: 1.6rem;
    line-height: 2.4rem;
  }
}
</style>
